import styled from 'styled-components';
import { color } from './asserts/styles/colors';
import MainRouter from 'router/MainRouter';
import GlobalAlert from 'components/Alert/GlobalAlert';

const App = () => {
  return (
    <Contaner>
      <MainRouter />
      <GlobalAlert />
    </Contaner>
  );
};

export default App;

const Contaner = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  background: ${color.bgDashBoard};
  color: ${color.white};
`;
